export default {
  pdfViewer: {
    ocorreuErro: 'There was an error loading the file',
    carregando: 'Loading...'
  }
};
